import { render, staticRenderFns } from "./OwnerOwnership.vue?vue&type=template&id=8b3c91ca&"
import script from "./OwnerOwnership.vue?vue&type=script&lang=js&"
export * from "./OwnerOwnership.vue?vue&type=script&lang=js&"
import style0 from "./OwnerOwnership.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports